// src/Components/Layout/HeaderPagina.jsx

import { useState, useEffect } from "react";
import { useDeudoresCBO } from "../Services/Deudores";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import {
  Typography,
  IconButton,
  Tooltip,
  Avatar,
  Menu,
  MenuItem,
  Box,
  Badge,
  TextField,
  Modal,
  Button,
  InputAdornment,
} from "@mui/material";

import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import { deepPurple } from "@mui/material/colors";
import { BsSearch, BsSearchHeart } from "react-icons/bs";

import { useUserSuperEmpresa } from "../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useBuscarPaciente } from "../Services/BusquedaPaciente";

import "../Css/Paginas.css";

import { InputBuscador, buttonCancelar, buttonGuardar, Texto, TituloColor, SubTitulo,Input } from "./CustomStyles";

const Titulo = {
  fontFamily: "Poppins",
  fontWeight: 600,
  fontSize: "1.3rem",
  color: "#585857",
};

const HeaderPagina = ({ titulo, notificaciones = [] }) => {
  const { Usuario } = useUserSuperEmpresa();
  const navigate = useNavigate();
  const roleId = Usuario?.id;
  const esRolLimitado = roleId === 3;


  const {
   
    buscarPaciente
  } = useBuscarPaciente();

  // BUSCADOR
  const [mostrarInput, setMostrarInput] = useState(false);
  const [rutBuscar, setRutBuscar] = useState("");

  // MODALES
  const [openModalSuccess, setOpenModalSuccess] = useState(false);
  const [openModalError, setOpenModalError] = useState(false);

  const [pacienteEncontrado, setPacienteEncontrado] = useState(null);

  // Fecha
  const fechaHoy = new Date().toLocaleDateString("es-CL", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

  // DEUDORES RECIENTES
  const { getDeudoresRecientes } = useDeudoresCBO();
  const [deudoresRecientes, setDeudoresRecientes] = useState([]);
  // Filtros y ordenamiento para la tabla de deudores
  const [filtroNombre, setFiltroNombre] = useState("");
  const [ordenarPor, setOrdenarPor] = useState("fecha");
  const [ordenDesc, setOrdenDesc] = useState(true);

  // Procesar deudores: agregar días de deuda, filtrar y ordenar
  const deudoresFiltradosOrdenados = deudoresRecientes
    .map((d) => {
      const fechaIngreso = new Date(d.fecha);
      const hoy = new Date();
      fechaIngreso.setHours(0,0,0,0);
      hoy.setHours(0,0,0,0);
      let diasDeuda = Math.floor((hoy - fechaIngreso) / (1000 * 60 * 60 * 24));
      if (diasDeuda < 0) diasDeuda = 0;
      return { ...d, diasDeuda };
    })
    .filter((d) => d.nombre_paciente.toLowerCase().includes(filtroNombre.toLowerCase()))
    .sort((a, b) => {
      let cmp = 0;
      if (ordenarPor === "nombre") {
        cmp = a.nombre_paciente.localeCompare(b.nombre_paciente);
      } else if (ordenarPor === "fecha") {
        cmp = new Date(a.fecha) - new Date(b.fecha);
      } else if (ordenarPor === "dias") {
        cmp = a.diasDeuda - b.diasDeuda;
      }
      return ordenDesc ? -cmp : cmp;
    });
  const [openModalDeudores, setOpenModalDeudores] = useState(false);
  const [anchorNotif, setAnchorNotif] = useState(null);
  const [loadingDeudores, setLoadingDeudores] = useState(false);

  useEffect(() => {
    const fetchDeudoresRecientes = async () => {
      setLoadingDeudores(true);
      try {
        const data = await getDeudoresRecientes();
        setDeudoresRecientes(data.deudores || []);
      } catch (e) {
        console.error("❌ Error al obtener deudores:", e);
        setDeudoresRecientes([]);
      } finally {
        setLoadingDeudores(false);
      }
    };
    fetchDeudoresRecientes();
  }, []);

  // Limpia rut
  const limpiarRut = (rut) =>
    rut.replace(/\./g, "").replace(/-/g, "").trim();

  // Función para convertir días en formato descriptivo
  const formatearDiasDeuda = (dias) => {
    if (dias === 0) return "0 días";
    
    const años = Math.floor(dias / 365);
    const mesesRestantes = Math.floor((dias % 365) / 30);
    const diasRestantes = dias % 30;
    
    const partes = [];
    
    if (años > 0) {
      partes.push(`${años} ${años === 1 ? 'año' : 'años'}`);
    }
    if (mesesRestantes > 0) {
      partes.push(`${mesesRestantes} ${mesesRestantes === 1 ? 'mes' : 'meses'}`);
    }
    if (diasRestantes > 0 || partes.length === 0) {
      partes.push(`${diasRestantes} ${diasRestantes === 1 ? 'día' : 'días'}`);
    }
    
    return partes.join(' ');
  };

  // Buscar paciente
  const handleBuscarPaciente = async () => {
    if (!rutBuscar.trim()) return;

    const rutLimpio = limpiarRut(rutBuscar);

    const result = await buscarPaciente(rutLimpio);

    if (result.ok) {
      setPacienteEncontrado(result.data);
      setOpenModalSuccess(true);          // éxito → abrir modal verde
    } else {
      setPacienteEncontrado(null);
      setOpenModalError(true);
      // error → abrir modal rojo
    }
  };




  // Ir a ficha paciente
  const handleIrFicha = () => {
    if (pacienteEncontrado.ingresos[0].paciente.rut) {
      setOpenModalSuccess(false); // 1) cerrar modal

      setTimeout(() => {
        navigate(`/paciente/${pacienteEncontrado.ingresos[0].paciente.rut}`); // 2) navegar después
      }, 150); // pequeño delay para permitir cerrar el modal
    }
  };



  return (
    <div style={{ height: "60px" }}>
      <div
        className="header-pagina"
        style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
      >

        <Typography gutterBottom sx={Titulo}>
          {titulo}
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
   {!esRolLimitado && (
      <>
          {/* INPUT BUSCADOR */}
          {mostrarInput && (
            <TextField
              autoFocus
              size="small"
              placeholder="Ingrese RUT del paciente"
              value={rutBuscar}
              onChange={(e) => setRutBuscar(e.target.value)}
              onKeyPress={(e) => e.key === "Enter" && handleBuscarPaciente()}
              sx={{
                ...InputBuscador,
                width: "260px",
                transition: "0.3s",
                "& .MuiInputBase-root": {
                  borderRadius: "20px",
                  background: "white",
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleBuscarPaciente}>
                      <BsSearch size={18} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          )}

         
          <Tooltip title="Buscar paciente">
            <IconButton
              onClick={() => setMostrarInput((prev) => !prev)}
              sx={{
                background: "#5fc562ff",
                "&:hover": {
                  background: "#4cb04eff",
                  transform: "scale(1.05)",
                },
              }}
            >
              <BsSearchHeart className="icon" style={{ color: "#fff", padding: 2 }} />
            </IconButton>
          </Tooltip>
  

          {/* NOTIFICACIONES DEUDORES */}
          <Badge color="error" variant={deudoresRecientes.length > 0 ? "dot" : undefined}>
            <Tooltip title={deudoresRecientes.length > 0 ? `Tienes notificaciones` : "Sin notificaciones"}>
              <IconButton
                sx={{
                  background: deudoresRecientes.length > 0 ? "#ffe082" : "#e2e265ff",
                  ...(deudoresRecientes.length > 0 ? { animation: 'heartbeat 1.2s infinite' } : {}),
                }}
                onClick={(e) => setAnchorNotif(e.currentTarget)}
                className={deudoresRecientes.length > 0 ? 'heartbeat-btn' : ''}
              >
                <NotificationsNoneIcon sx={{ color: "#60600bff" }} />
              </IconButton>
            </Tooltip>
          </Badge>

          {/* MENÚ DE NOTIFICACIONES */}
          <Menu anchorEl={anchorNotif} open={Boolean(anchorNotif)} onClose={() => setAnchorNotif(null)}>
            {deudoresRecientes.length > 0 ? (
              <MenuItem onClick={() => { setOpenModalDeudores(true); setAnchorNotif(null); }}>
                Deudores recientes ({deudoresRecientes.length})
              </MenuItem>
            ) : (
              <MenuItem disabled>No hay notificaciones</MenuItem>
            )}
          </Menu>
          </>
  )}
   <Tooltip title={`${Usuario?.name || "Usuario"}`}>
            <Avatar sx={{ bgcolor: deepPurple[500], cursor: "pointer" }}>
              {Usuario?.name?.charAt(0)?.toUpperCase() || "U"}
            </Avatar>
          </Tooltip>
          <Typography sx={{ fontFamily: "Poppins", fontSize: "0.9rem", color: "#585857" }}>
            {fechaHoy}
          </Typography>
        </Box>
      </div>

      <hr className="separador" />

      {/* MODAL ÉXITO */}
      <Modal open={openModalSuccess} onClose={() => setOpenModalSuccess(false)}>
        <Box sx={{
          width: 400, bgcolor: "white", p: 3, borderRadius: "10px",
          mx: "auto", mt: "15%", boxShadow: 5
        }}>
          <Typography variant="h6" sx={TituloColor}>Paciente encontrado</Typography>
          <Typography sx={{ ...SubTitulo, mt: 1, mb: 3 }}>
            ¿Deseas ver la ficha del paciente?
          </Typography>

          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button sx={buttonCancelar} onClick={() => setOpenModalSuccess(false)}>Cancelar</Button>
            <Button sx={buttonGuardar} variant="contained" onClick={handleIrFicha}>Ver ficha paciente</Button>
          </Box>
        </Box>
      </Modal>

      {/* MODAL ERROR */}
      <Modal open={openModalError} onClose={() => setOpenModalError(false)}>
        <Box sx={{
          width: 380, bgcolor: "white", p: 3, borderRadius: "10px",
          mx: "auto", mt: "18%", boxShadow: 5
        }}>
          <Typography variant="h6" sx={{ color: "red" }}>
            Paciente no encontrado
          </Typography>

          <Typography sx={{ mt: 2, mb: 3 }}>
            No existe un paciente con ese RUT.
          </Typography>

          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button variant="contained" color="error" onClick={() => setOpenModalError(false)}>
              Cerrar
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* MODAL DEUDORES */}
      <Modal open={openModalDeudores} onClose={() => setOpenModalDeudores(false)}>
        <Box sx={{
          width: 950,
          maxHeight: '80vh',
          bgcolor: "white",
          p: 3,
          borderRadius: "10px",
          mx: "auto",
          mt: "7%",
          boxShadow: 5,
          display: 'flex',
          flexDirection: 'column',
        }}>
          <Typography variant="h6" sx={{...Texto, color: "#b71c1c", mb: 2 }}>Deudores recientes</Typography>
          {/* Filtros y ordenamiento */}
          <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap' }}>
            <TextField
              size="small"
              label="Buscar por nombre"
              variant="outlined"
              onChange={e => setFiltroNombre(e.target.value)}
              value={filtroNombre}
              sx={{...Input, minWidth: 200 }}
            />
            <TextField
              size="small"
              select
              label="Ordenar por"
              value={ordenarPor}
              onChange={e => setOrdenarPor(e.target.value)}
              sx={{ ...Input,minWidth: 180 }}
            >
              <MenuItem value="nombre">Nombre</MenuItem>
              <MenuItem value="fecha">Fecha</MenuItem>
              <MenuItem value="dias">Días de deuda</MenuItem>
            </TextField>
            <TextField
              size="small"
              select
              label="Dirección"
              value={ordenDesc ? 'desc' : 'asc'}
              onChange={e => setOrdenDesc(e.target.value === 'desc')}
              sx={{ ...Input, minWidth: 120 }}
            >
              <MenuItem value="asc">Ascendente</MenuItem>
              <MenuItem value="desc">Descendente</MenuItem>
            </TextField>
          </Box>
          <Box sx={{ flex: 1, overflow: 'auto', mb: 2 }}>
            {loadingDeudores ? (
              <Typography>Cargando...</Typography>
            ) : deudoresRecientes.length === 0 ? (
              <Typography>No hay deudores recientes.</Typography>
            ) : (
              <TableContainer component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ whiteSpace: 'nowrap' }}>Nombre</TableCell>
                      <TableCell sx={{ whiteSpace: 'nowrap' }}>RUT</TableCell>
                      <TableCell sx={{ whiteSpace: 'nowrap' }}>Monto</TableCell>
                      <TableCell sx={{ whiteSpace: 'nowrap' }}>Previsión</TableCell>
                      <TableCell sx={{ whiteSpace: 'nowrap' }}>Fecha</TableCell>
                      <TableCell sx={{ whiteSpace: 'nowrap' }}>Sesiones</TableCell>
                      <TableCell sx={{ whiteSpace: 'nowrap' }}>Días de deuda</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {deudoresFiltradosOrdenados.map((d) => (
                      <TableRow key={d.id}>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>{d.nombre_paciente}</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>{d.rut}</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>${d.monto?.toLocaleString("es-CL")}</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>{d.prevision}</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>{d.fecha}</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>{d.n_sesiones}</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatearDiasDeuda(d.diasDeuda)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button variant="contained" sx={buttonCancelar} onClick={() => setOpenModalDeudores(false)}>Cerrar</Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default HeaderPagina;
